import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

import ChartStockFinacial from '../../chart/chartStockFinacial';

import * as _ from 'lodash';
import { getQ } from 'utils';
import { log } from 'utils';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function KetQuaKinhDoanh(props) {
  const { freqActive, setFreqActive, fsRatio, t, theme } = props;

  const [tongTaisan, setTongTaiSan] = React.useState([]);
  const [noNganHan, setNoNganHan] = React.useState([]);
  const [noDaiHan, setNoDaiHan] = React.useState([]);
  const [vonChuSH, setVonChuSH] = React.useState([]);

  const preFSRatio = usePrevious(fsRatio);

  React.useEffect(() => {
    if (fsRatio && !_.isEqual(fsRatio, preFSRatio)) {
      processData();
    }
  }, [fsRatio]);

  function processData() {
    const _doanhThuThuan = _.map(fsRatio, 'NET_REV');
    const _loiNhuanGop = _.map(fsRatio, 'GR_PROFIT');
    const _loiNhuanTuHDKD = _.map(fsRatio, 'OPERATING_INC');
    const _loiNhuanSauThue = _.map(fsRatio, 'NET_INC');

    const _time = _.map(fsRatio, 'REPORT_DATE');

    let __doanhThuThuan = [],
      __loiNhuanGop = [],
      __loiNhuanTuHDKD = [],
      __loiNhuanSauThue = [];

    // log(_time);

    for (let index = 0; index < _time.length; index++) {
      if (freqActive === 'Q') {
        __doanhThuThuan.push({
          name: getQ(_time[index]),
          value: _doanhThuThuan[index],
        });
        __loiNhuanGop.push({
          name: getQ(_time[index]),
          value: _loiNhuanGop[index],
        });
        __loiNhuanTuHDKD.push({
          name: getQ(_time[index]),
          value: _loiNhuanTuHDKD[index],
        });
        __loiNhuanSauThue.push({
          name: getQ(_time[index]),
          value: _loiNhuanSauThue[index],
        });
      } else {
        let st = new Date(_time[index].replace(/-/g, "/"));
        __doanhThuThuan.push({
          name: st.getFullYear() + '',
          value: _doanhThuThuan[index],
        });
        __loiNhuanGop.push({
          name: st.getFullYear() + '',
          value: _loiNhuanGop[index],
        });
        __loiNhuanTuHDKD.push({
          name: st.getFullYear() + '',
          value: _loiNhuanTuHDKD[index],
        });
        __loiNhuanSauThue.push({
          name: st.getFullYear() + '',
          value: _loiNhuanSauThue[index],
        });
      }
    }
    setTongTaiSan(__doanhThuThuan);
    setNoNganHan(__loiNhuanGop);
    setNoDaiHan(__loiNhuanTuHDKD);
    setVonChuSH(__loiNhuanSauThue);
  }

  // log(fsRatio);

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview"
      style={{ background: 'var(--bg_card_chart)', borderRadius: '2px' }}
    >
      <div className="d-flex pb-2" style={{ flexDirection: 'row-reverse' }}>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Y' ? 'active' : '')
          }
          onClick={() => setFreqActive('Y')}
        >
          {t('algo.ptcp.txt-Year')}
        </Button>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Q' ? 'active' : '')
          }
          onClick={() => setFreqActive('Q')}
        >
          {t('algo.ptcp.txt-Quarter')}
        </Button>
      </div>
      <div
        className="d-grid h-100"
        style={{
          gridTemplateColumns: 'repeat(2, minmax(0px, 1fr))',
          gap: '15px',
        }}
      >
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Net-revenue')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={tongTaisan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Gross-profit')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={noNganHan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Operating-profit')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={noDaiHan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Net-profit')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={vonChuSH}
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(KetQuaKinhDoanh);
